import {TableHeader as TableHeaderRoot} from './table-header';
import {TableHeaderSortable} from './components/table-header-sortable';

export const TableHeader = Object.assign(TableHeaderRoot, {
	Sortable: TableHeaderSortable,
});
